<template>
    <div class="c-o-table">
        <div style="font-size: 10pt;padding: 2px;float: right;color: gray;">
            <input
                type="checkbox"
                id="show_all"
                value="1"
                v-bind:checked="showAll"
                @click="setShowAndFetch($event.target.checked ? 1 : 0)"
            />
            Visa alla
        </div>

        <table class="c-o-table__table">
            <thead class="c-o-table__thead">
                <tr v-if="isDesktop" class="c-o-table__tr">
                    <th class="c-o-table__th">Förfrågan</th>
                    <th class="c-o-table__th">Datum</th>
                    <th class="c-o-table__th">Typ</th>
                    <th class="c-o-table__th">Kommun</th>
                    <th class="c-o-table__th">Kategori</th>
                    <th class="c-o-table__th c-o-table__th--center">Status</th>
                    <th class="c-o-table__th c-o-table__th--center">Dölj</th>
                </tr>
                <tr v-else class="c-o-table__tr">
                    <th class="c-o-table__th" :colspan="colspanAll">
                        Förfrågningar
                    </th>
                </tr>
            </thead>
            <tbody class="c-o-table__tbody" v-if="loading && !error">
                <tr class="c-o-table__tr">
                    <td class="c-o-table__td" :colspan="colspanAll">
                        <loader></loader>
                    </td>
                </tr>
            </tbody>
            <tbody class="c-o-table__tbody" v-else-if="!loading && error">
                <tr class="c-o-table__tr">
                    <td class="c-o-table__td" :colspan="colspanAll">
                        <error-state></error-state>
                    </td>
                </tr>
            </tbody>
            <tbody class="c-o-table__tbody" v-else-if="requests.length > 0">
                <table-row
                    v-for="request in requests"
                    :request="request"
                    :key="`request-${request.Id}`"
                    :highlightNew="highlightNew"
                    :isMatched="isMatched"
                ></table-row>
            </tbody>
            <tbody class="c-o-table__tbody" v-else>
                <tr class="c-o-table__tr">
                    <td class="c-o-table__td" :colspan="colspanAll">
                        <empty-state v-bind="emptyState"></empty-state>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import EmptyState from "../molecules/MoleculeEmptyState.vue";
import ErrorState from "../molecules/MoleculeErrorState.vue";
import Loader from "../molecules/MoleculeLoader.vue";
import TableRow from "../molecules/MoleculeRequestsListCompanyTableRow.vue";

import {
    FETCH_COMPANY_ANSWERED_REQUESTS,
    FETCH_COMPANY_REQUESTS,
    GET_SHOW_ALL,
    SET_SHOW_ALL
} from "../../../store/store-models/my-pages-company-model";

export default {
    props: {
        requests: {
            default: () => {
                return [];
            },
            type: Array
        },
        highlightNew: {
            default: true,
            type: Boolean
        },
        isMatched: {
            default: false,
            type: Boolean
        },
        loading: {
            default: true,
            type: Boolean
        },
        error: {
            default: false,
            type: Boolean
        },
        emptyState: {
            default: () => ({
                body: "<p>Det finns inga förfrågningar att visa här än.</p>",
                icon: ""
            }),
            type: Object
        }
    },
    components: {
        TableRow,
        Loader,
        ErrorState,
        EmptyState
    },
    data() {
        return {
            colspanAll: 7
        };
    },
    computed: {
        isDesktop: function() {
            return this.$mq === "medium" ||
                this.$mq === "large" ||
                this.$mq === "xLarge"
                ? true
                : false;
        },
        showAll: function() {
            var s = this.$store.getters[GET_SHOW_ALL];
            return s === 1;
        }
    },
    methods: {
        setShowAndFetch: function(showState) {
            this.$store.commit(SET_SHOW_ALL, showState);
            if (this.$parent.activeTab == "answered") {
                this.$store.dispatch(FETCH_COMPANY_ANSWERED_REQUESTS);
            } else {
                this.$store.dispatch(FETCH_COMPANY_REQUESTS);
            }
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/views/components/organisms/OrganismRequestsListCompanyTable.vue